/* eslint-disable no-invalid-this */
/* eslint-disable consistent-this */
/* eslint-disable max-lines-per-function */
/* eslint-disable func-style */

/*
 *=========== O - O ===========
 *
 *Updated AJAX add to cart for Duluth Pack
 *	- Started out as the add to cart interface for the upsell products on bask and prod.
 *		- Updated to be a general ajax add to cart using the Fetch api.
 *		- Setup instructions to be documented
 *			- Need to add additional mark-up to the add to cart form
 *			- For now, you need to use a <button> element
 *	- Initially tried sending the request as a JSON object (potentially to be used as a push to an Angular/Vue component)
 *	- Temporarily using the html response to update the mini-basket contents.
 *		- Without templates it would be cumbersome to recreate the HTML with vanilla JS. Could potentially use something like Mustache.
 *		- Ideally, I'd just want push JSON to the mini-basket template and have it updated automatically. This will have to wait until we have a Vue mini-basket component
 *	- Open to ideas and feedback.
 *
 *=========== O - O ===========
 */

import 'whatwg-fetch';


function openMiniBasket () {
	const miniBasket = document.querySelector('[data-hook="mini-basket"]');
	let miniBasketOpen = miniBasket.classList.contains('x-mini-basket--open');

	if (typeof miniBasket !== 'undefined' && !miniBasketOpen) {
		setTimeout(() => {
			document.querySelector('[data-hook="open-mini-basket"]').click();
		}, 100);
	}
};

function constructFeedbackMessage (id, response) {
	const messageContainers = document.getElementsByClassName(`js-cart-message--${ id }`);

	if (messageContainers) {
		let message = response.message;
		let status = response.status;

		for (let messageContainer of messageContainers) {
			switch (status) {
			case 200:
				messageContainer.innerHTML = message;
				break;
			default:
				messageContainer.innerHTML = '<span class="u-color-red">' + message + '</span>';
				break;
			}

			messageContainer.classList.remove('u-hidden');

			setTimeout(function () {
				messageContainer.classList.add('u-hidden');
			}, 5000);
		}
	}
};

function constructMiniBasketCount (count) {
	const miniBasketCounters = document.getElementsByClassName('js-mini-basket-count');

	for (let miniBasketCounter of miniBasketCounters) {
		miniBasketCounter.innerText = count;
	}
};

function constructMiniBasketItems (html) {
	const miniBasketListElement = document.getElementById('js-mini-basket__list');

	if (miniBasketListElement) {
		miniBasketListElement.innerHTML = html;
	}
};

// Specific for duluth
function constructMiniBasketUpsell (upsell) {
	const upsellProducts = document.getElementById('js-upsell-products');

	if (upsellProducts) {
		if (upsellProducts.classList.contains('u-hidden')) {
			upsellProducts.classList.remove('u-hidden');
		}
		upsellProducts.innerHTML = upsell;
	}
};

function constructMiniBasketCharges (html) {
	const miniBasketChargesElement = document.getElementById('js-mini-basket__charges');
	const miniBasketFooterElement = document.getElementById('js-mini-basket__footer');

	if (miniBasketChargesElement) {
		miniBasketChargesElement.innerHTML = html;
	}

	if (miniBasketFooterElement && miniBasketFooterElement.classList.contains('u-hidden')) {
		miniBasketFooterElement.classList.remove('u-hidden');
	}

	openMiniBasket();
};

function constructMiniBasket (basket, html) {
	constructMiniBasketCount(basket.count);
	constructMiniBasketItems(html.items);
	constructMiniBasketUpsell(html.upsell);
	constructMiniBasketCharges(html.charges);

	// eslint-disable-next-line no-use-before-define
	initializeProductPurchase();
};

function updateButtonClass (ele, ele_class) {
	if (!ele.classList.contains(ele_class)) {
		ele_class.replace(/[^_-a-z0-9]/ig, '');
		ele.classList.add(ele_class);
	}
};

function updateButtonText (ele, text) {
	ele.innerHTML = text;
};

function gtmAddedToCart (data) {
	if (typeof window.google_tag_manager !== 'object' || !data.added_item || !data.added_item.product_id || !data.basket || !data.basket.items) {
		return;
	}

	const addedItem = data.added_item;
	const addedItemVariant = [];

	if (addedItem.options.length > 0) {
		for (let i = 0, optionLen = addedItem.options.length; i < optionLen; i++) {
			if (addedItem.options[i].option_id) {
				addedItemVariant.push(addedItem.options[i].opt_prompt);
			} else if (addedItem.options[i].data.length === 0 && addedItem.options[i].data_long.length === 0) {
				addedItemVariant.push(addedItem.options[i].attr_prompt);
			}
		}
	}

	const addedItemForm = document.querySelector('[data-hook="purchase"]');
	const addedItemQty = addedItemForm.querySelector('[name="Quantity"]').value;

	window.dataLayer = window.dataLayer || [];

	window.dataLayer.push({
		ecommerce: null
	});

	window.dataLayer.push({
		ecommerce: {
			add: {
				products: [
					{
						id: addedItem.code,
						/* eslint-disable camelcase */
						item_id: addedItem.code,
						item_name: addedItem.name,
						item_variant: addedItemVariant.join(', '),
						/* eslint-enable camelcase */
						name: addedItem.name,
						price: addedItem.price,
						quantity: addedItemQty,
						variant: addedItemVariant.join(', ')
					}
				]
			},
			currencyCode: mivaJS.Currency_Code
		},
		event: 'addToCart',
		/* eslint-disable camelcase */
		ga_event_action: 'Add To Cart',
		ga_event_category: 'Ecommerce',
		ga_event_label: '',
		ga_event_noninteraction_hit: false,
		ga_event_value: ''
		/* eslint-enable camelcase */
	});
}

function klaviyoAddedToCart (data) {
	if (typeof window._learnq !== 'object' || !data.added_item || !data.added_item.product_id || !data.basket || !data.basket.items) {
		return;
	}

	if (typeof Array.prototype.unique !== 'function') {
		Array.prototype.unique = function () {
			var a = [];
			var l = this.length;

			for (var i = 0; i < l; i++) {
				if (a.indexOf(this[i]) === -1) {
					a.push(this[i]);
				}
			}

			return a;
		};
	}

	const basketItems = data.basket.items;
	const itemNames = [];
	const itemData = [];

	basketItems.forEach((item) => {
		itemNames.push(item.name);
		itemData.push({
			ImageURL: item.main_img,
			ItemPrice: item.price,
			ProductCategories: item.categories ? item.categories.map(category => category.name) : [],
			ProductID: item.product_id,
			ProductName: item.name,
			ProductURL: item.link,
			Quantity: item.quantity,
			RowTotal: item.subtotal,
			SKU: item.code
		});
	});

	const addedItem = data.added_item;

	window._learnq.push([
		'track',
		'Added to Cart',
		{
			$value: data.basket.total_raw || 0,
			AddedItemCategories: addedItem.categories ? addedItem.categories.map(category => category.name) : [],
			AddedItemImageURL: addedItem.main_img,
			AddedItemPrice: addedItem.price,
			AddedItemProductID: addedItem.product_id,
			AddedItemProductName: addedItem.name,
			AddedItemQuantity: addedItem.quantity,
			AddedItemSKU: addedItem.code,
			AddedItemURL: addedItem.link,
			CheckoutURL: data.checkout_url || '',
			ItemNames: itemNames.unique,
			Items: itemData
		}
	]);
}

function addToCart (e) {
	e.preventDefault();
	e.stopImmediatePropagation();

	// Define button element
	let buttonElement = this;
	let buttonText = buttonElement.getAttribute('data-text');
	let buttonClass = buttonElement.getAttribute('data-class');
	let productId = buttonElement.getAttribute('data-prodid');

	// Define form element
	let buttonForm = buttonElement.form;
	let formAction = buttonForm.action;
	let formMethod = buttonForm.method;
	let formData = new FormData(buttonForm);

	// Append flag for the basket page
	formData.append('js_request', 1);

	// Disable submit button
	buttonElement.setAttribute('disabled', 'disabled');

	fetch(
		formAction,
		{
			body: formData,
			method: formMethod
		}
	)
		.then((response) => response.json())
		.then((data) => {
			if (data.status === 200) {
				// Update mini basket
				constructMiniBasket(data.basket, data.html);

				// Update button text
				if (buttonText) {
					updateButtonText(buttonElement, buttonText);
				}

				// Update button class
				if (buttonClass) {
					updateButtonClass(buttonElement, buttonClass);
				}

				// GTM added to cart data layer push
				gtmAddedToCart(data);

				// Klaviyo added to cart tracking
				klaviyoAddedToCart(data);
			}

			// Send feedback message
			if (data.status) {
				constructFeedbackMessage(productId, data);
			}

			// Remove button disable
			buttonElement.removeAttribute('disabled');
		})
		.catch((error) => {
			if (error) {
			// Creating a static message for now

				console.error(error);

				let data = {
					message: 'There was an error with your request, please try again or contact us for assistance',
					status: 400
				};

				// Send feedback message
				constructFeedbackMessage(productId, data);
			}

			// Remove button disable
			buttonElement.removeAttribute('disabled');
		});
};

export function initializeProductPurchase () {

	const productButtons = document.getElementsByClassName('js-purchase-product');
	const instantiatedClass = 'js-purchase-product__initalized';

	for (let button of productButtons) {

		if (!button.classList.contains(instantiatedClass)) {
			button.classList.add(instantiatedClass);
			button.addEventListener('click', addToCart, false);
		}

	}

}

